import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[emptyStateTitle]',
    host: { class: 'empty-state-title' },
})
export class EmptyStateTitleDirective
{
    constructor(public _el: ElementRef) {
    }

    get title() {
        return this._el.nativeElement.textContent;
    }
}

@Directive({
    selector: '[emptyStateText]',
    host: { class: 'empty-state-text' },
})
export class EmptyStateTextDirective
{
    constructor(public _el: ElementRef) {
    }

    get text() {
        return this._el.nativeElement.textContent;
    }
}
